export default __webpack_public_path__ + "static/media/Menu_Icon_Dashboard.2ca6206d.svg";